import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { emptySelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/empty-selection-state';
import { TaxonomyIndicatorBoxes } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/data-area/taxonomy-kpi-boxes';
import { TaxonomyLensEmptyState } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/empty-state';
import { TaxonomyInfoBoxes } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/info-boxes';
import { TaxonomyInfoBoxConnectors } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/info-boxes/connectors';
import { taxonomyLensTexts } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/texts';
import { TaxonomyLensData, TaxonomyLensOptions } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';

export const taxonomyLens: ImpactLens<ImpactLensType.EU_TAXONOMY, TaxonomyLensData, TaxonomyLensOptions> = {
  type: ImpactLensType.EU_TAXONOMY,
  ImpactDataComponent: { component: TaxonomyIndicatorBoxes },
  infoBoxes: {
    DivComponent: TaxonomyInfoBoxes,
    SvgComponent: TaxonomyInfoBoxConnectors,
  },
  EmptyState: TaxonomyLensEmptyState,
  boxMode: (fullWidth: number) => {
    if (fullWidth > 1000) {
      return LensBoxMode.SIDE;
    } else if (fullWidth > 600) {
      return LensBoxMode.FLOAT;
    } else {
      return LensBoxMode.MODAL;
    }
  },
  centerAreaWidth: (fullWidth: number) => {
    if (fullWidth < 500) {
      return 140;
    }
    return undefined;
  },
  ...emptySelectionState,
  ...taxonomyLensTexts,
};
